import { render, staticRenderFns } from "./403.vue?vue&type=template&id=6cd061da&scoped=true"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"
import style0 from "./403.vue?vue&type=style&index=0&id=6cd061da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd061da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cd061da')) {
      api.createRecord('6cd061da', component.options)
    } else {
      api.reload('6cd061da', component.options)
    }
    module.hot.accept("./403.vue?vue&type=template&id=6cd061da&scoped=true", function () {
      api.rerender('6cd061da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/error-page/403.vue"
export default component.exports